module.exports = __webpack_public_path__ + "img/plus.11da4a8e.svg";